import { ComponentView, View } from "binder"
import { ToggleButtonViewModel } from "./toggleButton-viewModel"

export class ToggleButtonView extends ComponentView<ToggleButtonViewModel>{
    GetViewUniqueId(): string {
        return "V-9DF30B0E-45DC-4521-97E6-04CC3610398D"
    }
    loadHtml(): string {
        let element = require('./toggleButton.html').default;
        let style = require('./toggleButton.less');
        return element;
    }
    constructor() {
       super();
    }
    public set content(v: string) { this._content = v; } public get content(): string { return this._content;} private _content: string;
    public set isselected(v: boolean) { this._isselected = v; } public get isselected(): boolean { return this._isselected;} private _isselected: boolean;

    click(){
        this.dataContext.click();
    }
}
